import { useCallback, useMemo } from 'react';
import { format } from 'date-fns';

import { useGetRelatorioAprovacaoCalendarioQuery } from 'services/api/products/relatorios';
import { RelatorioAprovacaoConfig } from 'helper/Relatorios/Aprovacao/config';
import { mapearCalendario } from 'helper/Relatorios/Aprovacao';
import { CalendarioParams, EdicaoStatus } from 'types/Relatorios/Aprovacao';

export interface UseRelatorioCalendario {
  isLoading: boolean;
  isError: boolean;
  statusDoDia: (date: Date) => EdicaoStatus | undefined;
}

/**
 * Busca o calendário de publicação do mês visível no `ControlPanel`. `skip` quando o
 * informe está desabilitado — `statusDoDia` devolve sempre `undefined` e o
 * `ControlPanel` fica idêntico ao comportamento anterior.
 */
export default function useRelatorioCalendario(
  config: RelatorioAprovacaoConfig,
  mesVisivel: Date,
  variante: string,
): UseRelatorioCalendario {
  const habilitado = config.habilitado();
  const mes = useMemo(() => format(mesVisivel, 'yyyy-MM'), [mesVisivel]);
  const { informe, variante: { campo } } = config;

  const params = useMemo<CalendarioParams>(() => (
    campo === 'modo' ? { informe, mes, modo: variante } : { informe, mes, cenario: variante }
  ), [informe, campo, mes, variante]);

  const { currentData, isLoading, isError } = useGetRelatorioAprovacaoCalendarioQuery(
    params,
    { skip: !habilitado },
  );

  const porData = useMemo(() => (
    currentData ? mapearCalendario(currentData) : {}
  ), [currentData]);

  const statusDoDia = useCallback((date: Date) => (
    porData[format(date, 'yyyy-MM-dd')]
  ), [porData]);

  return { isLoading, isError, statusDoDia };
}
